import AvailableStartDate from '@/lib/enums/propertyRequest/AvailableStartDate'

export function usePropertyRequest() {
  const isPropertyRequestUrgent = (lead, type: string): boolean => {
    return Boolean(
      lead?.conversions &&
        type === 'PROPERTY_REQUEST' &&
        lead.conversions.find(
          (current) => current.propertyRequest?.availableStartDate === AvailableStartDate.EARLIEST
        ) &&
        lead.currentStatus === 'new'
    )
  }

  return {
    isPropertyRequestUrgent,
  }
}
